// animations.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.config({
  nullTargetWarn: true,
});

const onceIn = document.querySelectorAll(".once-in");
onceIn.forEach((item) => {
  gsap.to(item, {
    scrollTrigger: {
      trigger: item,
      start: "top 100%",
      // markers:true,
    },
    duration: 0.8,
    autoAlpha: 1,
    ease: "Power4.easeInOut",
  });
});

// animate years in timeline
gsap.utils.toArray(".timeline--item").forEach((item) => {
  gsap.from(item, {
    opacity: 0,
    y: "+=24",
    scrollTrigger: {
      trigger: item,
      start: "top bottom",
      end: "+=30%",
      scrub: 2,
      // markers:true
    },
  });
});
